import type { FC, ReactNode } from 'react';
import { QText } from '..';
import { DataProps } from '../../utils';

export type QSubtitleProps = DataProps & {
  children?: ReactNode;
};

export const QSubtitle: FC<QSubtitleProps> = ({ children, ...rest }) => (
  <QText maxWidth="720px" fontSize="sm" {...rest}>
    {children}
  </QText>
);

QSubtitle.displayName = 'QSubtitle';
